import Component from '@Component';
import { inViewEventListener } from '@Utility';

export default class TitleCard extends Component {
  static selector = '[data-comp-title-card]';

  constructor(element) {
    super(element);
    this.initialPadding = /\(([^)]+)\)/.exec(getComputedStyle(this.$container).getPropertyValue('clip-path'));

    this.fromBottom = 0.35;
    this.speedModifier = 2.5;

    this.onScroll();
    inViewEventListener(this.$container, () => this.onScroll(), 'scroll');
  }

  onScroll() {
    requestAnimationFrame(() => {
      this.$container.style.setProperty('--abs-percent', this.getPercentVisibleAbs());
      if (this.getPercentScrolled() >= this.fromBottom && this.getPercentScrolled() <= 1) {
        this.$container.style.setProperty('--percent', this.speedModifier * (1 - this.getPercentScrolled() - this.fromBottom));
        this.$container.style.removeProperty('--opacity');
      } else if (this.getPercentScrolled() < this.fromBottom) {
        this.$container.style.removeProperty('--percent');
        this.$container.style.removeProperty('--opacity');
      } else if (this.getPercentScrolled() > 1) {
        this.$container.style.setProperty('--opacity', this.getPercentVisible());
      }
    });
  }

  getPercentScrolled() {
    return 1 - (this.$container.offsetTop - (window.pageYOffset)) / (window.innerHeight);
  }

  getPercentVisible() {
    return 1 + (this.$container.offsetTop - window.pageYOffset) / this.$container.clientHeight;
  }

  getPercentVisibleAbs() {
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY;
    const elementOffsetTop = this.$container.offsetTop - scrollTop;
    const elementHeight = this.$container.offsetHeight;

    const distance1 = Math.min(elementHeight, viewportHeight - elementOffsetTop) / elementHeight;
    const distance2 = 1 + (this.$container.offsetTop - window.pageYOffset) / this.$container.clientHeight;

    const percentage = Math.max(0, elementOffsetTop > 0 ? distance1 : distance2);

    return percentage;
  }
}
